import axios from 'axios'
import getMeta from "../../admin/js/infra/getMeta";

let csrf = getMeta('csrf-token')
let token = getMeta('app-token')

export default axios.create({
    headers: {
        'X-CSRF-Token': csrf,
        'Authorization': 'Bearer ' + token
    }
})
